export function errorMessage(status: number): string {
  let msg: string;
  if (status === 400) msg = 'Interface error';
  // else if (status === 401) msg = 'Authentication error'; // this is replaced with an error message returned from the backend. Main use case - admin dashboard for the password check
  else if (status === 403) msg = 'Permission error';
  else if (status === 404) msg = 'Object not found';
  else if (status === 413) msg = 'File size exceeds the limit';
  else if (status === 415) msg = 'Interface error';
  else if (status >= 500 && status < 600) msg = 'Server error';
  else msg = 'An unknown error has occurred';
  return msg;
}
